import React, { useEffect, useState } from "react";
import { Table, Button, Search, IconDownload, Select, Modal, TextBox, InlineNotification } from "@veneer/core";
import ConnectAPI from '../../../services/api';
import Swal from 'sweetalert2';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { Col, Row } from "react-bootstrap";
import XLSX from "xlsx";
import $ from 'jquery';

const SpecialConditionApproversView = ( props ) => {
    //Variables
    const [t] = useTranslation();
    const connectApi = new ConnectAPI();
    const [dataSCAV, setDataSCAV] = useState([]);
    const [dataAddSCA, setDataAddSCA] = useState([]);
    const [channelView, setChannelView] = useState([]);
    const [loadingData, setLoadingData] = useState(false);
    const [regionList] = useState([
        { value: 2, label: 'Brazil' }, { value: 3, label: 'Mexico' },
        { value: 31, label: 'MCA NORTH' }, { value: 32, label: 'MCA SOUTH' },
    ]);
    const [levelList] = useState([
        { value: 1, label: '1. Supplies Country Managers' }, { value: 2, label: '2. LAR Supplies Managers' },
        { value: 3, label: '3. CBM' }, { value: 4, label: '4. Channel Partner' },
    ]);
    var fetchData;

    //Metodos
    useEffect(() => {
        //validate location
        let currentUser = JSON.parse(localStorage.getItem("currentUser"));
        let validate=false;
        currentUser.urls.forEach(ur=>{
            if (ur==window.location.pathname){
                validate=true;
            }
        });
        if (validate==false){
            const { history } = props;
            history.push({
                pathname: '/' 
            });
        }
        //end validate
        fetchData();
    },[] );
    fetchData = async () => {
        connectApi.get(
            "api/Channels/SCAprroversView",
            '',
            dataResponseLoad
        ).catch((error) => {
            setLoadingData(false);
            Swal.fire(
                "Error " + error.response,
                error.response,
                "error"
            );
        });
        setLoadingData(true);
    };
    const dataResponseLoad = (status, data) => {
        const dataAddLevels = data['userSCAprrovalViewList'].map((item) => {
            item.levelName = ( 
                item.approvalLevel == 1 ? ('1. Supplies Country Managers') :
                ( item.approvalLevel == 2 ? ('2. LAR Supplies Managers') :
                ( ( item.approvalLevel == 3 ? ('3. CBM') : ('4. Channel Partner') ) ) ) 
            );
            return item;
        });
        setDataSCAV(dataAddLevels === undefined ? [] : dataAddLevels );
        setDataAddSCA(data['userSCAprrovalToAdd'] === undefined ? [] : data['userSCAprrovalToAdd'] );
        let result = data['userSCAprrovalToAdd'].map(x => [x.idCustomer, x.customer]).reduce((acc, [idCustomer, customer]) => {
            if (!acc.some(item => item.value === idCustomer))
                acc.push({ value: idCustomer, label: customer });
            return acc;
        }, []);
        setChannelView(result)
        
        let numero = Math.ceil(data.length / pageSize) || 1;
        if(numero < currentPage)
            setCurrentPage(numero);
        
        setLoadingData(false)
    };

    function descendingComparator(a, b, orderBy) {
        const aSort = a[orderBy] && a[orderBy].toString().toUpperCase();
        const bSort = b[orderBy] && b[orderBy].toString().toUpperCase();
        if( orderBy === t("approvalLevel")  ){
            if (parseInt(bSort) < parseInt(aSort))
                return -1;
            if (parseInt(bSort) > parseInt(aSort))
                return 1;
        } else {
            if (bSort < aSort)
                return -1;
            if (bSort > aSort)
                return 1;
        }
        return 0;
    }
    function filterSort(array, filters, orderBy, orderType) {
        let arrayFiltered = array;
        Object.keys(filters).forEach((value) => {
            const filterValue = filters[value];
            const filter = typeof filterValue === "object" ? filterValue[0] : filterValue;
            if (filter)
                arrayFiltered = arrayFiltered.filter((a) => {
                const aUpper = a[value] && a[value].toString().toUpperCase();
                const filterUpper = filter && filter.toString().toUpperCase();
                return aUpper.indexOf(filterUpper) > -1;
                });
            });
        return arrayFiltered.sort((a, b) => {
            const value = (orderType === 'descending')
            ? descendingComparator(a, b, orderBy) : -descendingComparator(a, b, orderBy);
            return value;
        });
    }
    
    //Vistas
    const [orderBy, setOrderBy] = useState("customer");
    const [orderType, setOrderType] = useState("descending");
    const [channelFilter, setChannelFilter] = useState("");
    const [emailFilter, setEmailFilter] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const pageSize = 25;
    const [order, setOrder] = useState([
        'customer',
        'name',
        'jobPosition',
        'idUser',
        'idCountry',
        'subRegion',
        'levelName'
    ]);
    const handlePageChange = (page) => setCurrentPage(page);
    const filteredData = filterSort(
        dataSCAV,
        {
            customer: channelFilter,
            idUser: emailFilter
        },
        orderBy,
        orderType
    );
    let pagedData = filteredData.slice(
        (currentPage - 1) * pageSize,
        (currentPage - 1) * pageSize + pageSize
    );
    const handleSort = (_, { id, type }) => {
        setOrderBy(id);
        setOrderType(type);
    };
    
    //Modal
    const [showModal, setShowModal] = useState(false);
    const [idChannel, setIdChannel] = useState();
    const [emailSCA, setEmailSCA] = useState(undefined);
    const [mailOPT, setMailOPT] = useState([]);
    const [userSelect, setUserSelect] = useState([]);
    const [userName, setUserName] = useState("");
    const [userJobP, setUserJobP] = useState("");
    const [userSubR, setUserSubR] = useState({value: []});
    const [userLvl, setUserLvl] = useState([]);
    const [userLvlLock, setUserLvlLock] = useState(true);
    const [showNotification, setShowNotification] = useState(false);
    const [notificationDetails, setNotificationDetails] = useState({ title: '', type: '', description: '' });

    function closeModal (){
        setIdChannel(undefined);
        setEmailSCA(undefined);
        setMailOPT([]);
        setUserName("");
        setUserJobP("");
        setUserSubR({ value: [] });
        setUserLvl([]);
        setUserLvlLock(true);
        setShowNotification(false);
        setShowModal(false);
        
        setModifyFlag(false);
        setHPFlag(true);
        setDeleteFlag(false);
    }

    const updateListUser = (val) => {
        if( val.value != "HP" ){
            setUserLvl([4]);
            setUserLvlLock(true);
        } else {
            setUserLvlLock(false);
            setHPFlag(false);
            setUserLvl([]);
        }
        setEmailSCA(undefined);
        setIdChannel([val.value]);
        let list = dataAddSCA.filter(x => x.idCustomer == val.value );
        setMailOPT(list.map( x => ({ value: x.idUser, label: x.idUser })))
        setUserName("");
        setUserJobP("");
        setUserSubR({ value: [] });
        setShowNotification(false);
    }
    const updateSelecttUser = (val) => {
        setEmailSCA([val.value]);
        let user = dataAddSCA.filter(x => x.idUser == val.label );
        setUserSelect(user);
        setUserName(user[0].name);
        setUserJobP(user[0].jobPosition);
        asignedSubRegions(user[0], true);
    }
    const asignedSubRegions = (user, flag) => {
        let str = "";
        if(flag)
            str = user.idSubRegion;
        else 
            str = user.subRegion;
        const valueCopy = [];
            const arr = str.split(',');
            arr.forEach((x) => {
                let item;
                if(flag)
                    item = regionList.find((y) => y.value === Number(x.trim()));
                else
                    item = regionList.find((y) => y.label === x.trim());
                if(item)
                    valueCopy.push(item.value);
            });
            setUserSubR({ value: valueCopy });
    }
    const handleChangeSubRegions = ({ value }) => {
        const valueCopy = [...userSubR.value];
        const isOptionSelected = valueCopy.includes(value);
        if (isOptionSelected) {
          const index = valueCopy.indexOf(value);
          valueCopy.splice(index, 1);
        } else
          valueCopy.push(value);
        
        setUserSubR({ value: valueCopy });
    }

    function addNewSCAprover(){
        if( userName == "" ){
            setNotificationDetails({
                title: "Error",
                type: 'negative',
                description: t('errorName')
            });
            setShowNotification(true);
        } else if ( userJobP == "" ){
            setNotificationDetails({
                title: "Error",
                type: 'negative',
                description: t('errorJob')
            });
            setShowNotification(true);
        } else if ( userSubR.value.length == 0 ){
            setNotificationDetails({
                title: "Error",
                type: 'negative',
                description: t('errorRegions')
            });
            setShowNotification(true);
        } else {
            let data = new FormData();
                data.append("Action", "NewSCAprovedUser");
                data.append("userId", userSelect[0].idUser);
                data.append("userName", userName);
                data.append("userJob", userJobP);
                data.append("regions", userSubR.value);
                data.append("nivel", userLvl);
            const handleUploadResponse = (status, response) => {
                if (response === 'allGood') {
                    setNotificationDetails({
                        title: t('notifyAllCorrect'),
                        type: 'positive',
                        description: ''
                    });
                } else {
                    setNotificationDetails({
                        title: "Error",
                        type: 'negative',
                        description: t('notifySQLError')
                    });
                }
                setShowNotification(true);
                setTimeout(() => {
                    closeModal();
                    fetchData();
                }, 900);
            }
            connectApi.post(
                "api/Channels/uploadSCPAdd",
                data,
                handleUploadResponse
            ).catch((error) => {
                setShowModal(false);
                Swal.fire(
                    "Error " + error.response.status,
                    error.response.data, "error"
                );
            });
        }
    }
    function modifyReg(e) {
        var channel = $(e.target).closest('tr').children().eq(0).text();
        var email = $(e.target).closest('tr').children().eq(3).text();
        if( email !== t("Email") & channel !== t("channel") & email !== "" & channel !== '' ){
            let user = dataSCAV.find(u => u.idUser == email);

            const matchingUsers = dataSCAV.filter(x => x.idCustomer === user.idCustomer 
                && x.approvalLevel === user.approvalLevel && x.idUser !== user.idUser
            );
            const combinedRegions = new Set();
            matchingUsers.forEach(x => { x.subRegion.split(',').map(r => r.trim()).forEach(region => combinedRegions.add(region)); });
            const userRegions = user.subRegion.split(',').map(r => r.trim());
            const isCovered = userRegions.every(region => combinedRegions.has(region));

            setModifyFlag(true);
            if(user.idCustomer == 'HP'){
                setHPFlag(false);
                setUserLvlLock(false);
            }

            if(isCovered) setDeleteFlag(true);

            setUserSelect(user);
            setIdChannel([user.idCustomer]);
            setMailOPT([{ value: user.idCustomer, label: user.idUser }])
            setEmailSCA([user.idCustomer]);
            setUserName(user.name);
            setUserJobP(user.jobPosition);
            setUserLvl([user.approvalLevel])

            asignedSubRegions(user, false);
            
            setShowModal(true);
        }
    }
    function deledModify(mode){
        const nextStep = () => {
            let data = new FormData();
            data.append("Action", "UpdateUser");
            data.append("Mode", mode);
            data.append("userId", userSelect.idUser);
            data.append("channel", userSelect.idCustomer);
            data.append("userName", userName);
            data.append("userJob", userJobP);
            data.append("regions", userSubR.value);
            data.append("nivel", userLvl);
            const handleUploadResponse = (status, response) => {
                if (response === 'allGood') {
                    setNotificationDetails({
                        title: t('notifyAllCorrect'),
                        type: 'positive',
                        description: ''
                    });
                } else {
                    setNotificationDetails({
                        title: "Error",
                        type: 'negative',
                        description: t('notifySQLError')
                    });
                }
                setShowNotification(true);
                setTimeout(() => {
                    closeModal();
                    fetchData();
                }, 900);
            }
            connectApi.post(
                "api/Channels/uploadSCPAdd",
                data,
                handleUploadResponse
            ).catch((error) => {
                setShowModal(false);
                Swal.fire(
                    "Error " + error.response.status,
                    error.response.data, "error"
                );
            });
        }
        if(mode == "Modify" && userSelect.idCustomer != "HP"){
            if( userName == "" ){
                setNotificationDetails({
                    title: "Error",
                    type: 'negative',
                    description: t('errorName')
                });
                setShowNotification(true);
            } else if ( userJobP == "" ){
                setNotificationDetails({
                    title: "Error",
                    type: 'negative',
                    description: t('errorJob')
                });
                setShowNotification(true);
            } else if( userName == userSelect.name && userJobP == userSelect.jobPosition ){
                setNotificationDetails({
                    title: "Error",
                    type: 'negative',
                    description: t('errorLostModify')
                });
                setShowNotification(true);
            } else {
                nextStep();
            }
        } else if (mode == "Modify" && userSelect.idCustomer == "HP"){
            if( userName == "" ){
                setNotificationDetails({
                    title: "Error",
                    type: 'negative',
                    description: t('errorName')
                });
                setShowNotification(true);
            } else if ( userJobP == "" ){
                setNotificationDetails({
                    title: "Error",
                    type: 'negative',
                    description: t('errorJob')
                });
                setShowNotification(true);
            } else if ( userSubR.value.length == 0 ){
                setNotificationDetails({
                    title: "Error",
                    type: 'negative',
                    description: t('errorRegions')
                });
                setShowNotification(true);
            } else if ( userLvl == [] ){
                setNotificationDetails({
                    title: "Error",
                    type: 'negative',
                    description: t('errorLevel')
                });
                setShowNotification(true);
            } else if( userName == userSelect.name && userJobP == userSelect.jobPosition
                && userSubR.value.length == userSelect.subRegion.split(',').length && userLvl == userSelect.approvalLevel
             ){
                setNotificationDetails({
                    title: "Error",
                    type: 'negative',
                    description: t('errorLostModify')
                });
                setShowNotification(true);
            } else {
                nextStep();
            }
        } else {
            nextStep();
        }
    }

    const [modifyFlag, setModifyFlag] = useState(false);
    const [hpFlag, setHPFlag] = useState(true);
    const [deleteFlag, setDeleteFlag] = useState(false);

    return (
        <div>
            <Modal
                id="form-modal"
                onClose={closeModal}
                closeButton={true}
                show={showModal}
                title={modifyFlag?(t("modify")):(t("addNewValue"))}
                footer={(
                    <div className="vn-button-group--responsive">
                        {showNotification ? (
                            <div className="show-animated" >
                                <InlineNotification
                                    title={notificationDetails.title}
                                    type={notificationDetails.type}
                                    description={notificationDetails.description}
                                    onClose={() => { setShowNotification(false) }}
                                /> 
                            </div>):("")
                        }
                        <br />
                        {modifyFlag?(
                            <div>
                                <Button onClick={() => deledModify("Modify")} style={{marginRight: '5px'}} >{t('modify')}</Button> 
                                {deleteFlag?(<Button onClick={() => deledModify("Delete")} style={{marginRight: '5px'}} appearance="danger">{t('delete')}</Button>):("")}
                                <Button appearance="secondary" onClick={closeModal}>{t('cancel')}</Button>
                            </div>
                        ) : (
                            <div> 
                                <Button style={{marginRight: '5px'}} appearance="success" onClick={addNewSCAprover} >{t('addNew')}</Button>
                                <Button appearance="secondary" onClick={closeModal}>{t('cancel')}</Button>
                            </div>
                        )}
                    </div>
                )}
            >
                <label>{t("channel")}</label>
                <Select
                    clearIcon={false}
                    value={idChannel}
                    options={channelView}
                    onChange={val => updateListUser(val)}
                    placeholder={t('select_channel')}
                    readOnly={modifyFlag}
                /> <br />
                <label>{t('Email')}</label>
                <Select
                    clearIcon={false}
                    value={emailSCA}
                    options={mailOPT}
                    onChange={(val) => updateSelecttUser(val)}
                    placeholder={t('selectEndUser')}
                    readOnly={modifyFlag}
                /> <br />
                <label>{t('contactName')}</label>
                <TextBox
                    id="name"
                    value={userName}
                    onChange={(val) => setUserName(val)}
                    error={userName == ""}
                /> <br />
                <label>{t('jobPosition')}</label>
                <TextBox
                    id="jobPosition"
                    value={userJobP}
                    onChange={(val) => setUserJobP(val)}
                    error={userJobP == ""}
                /> <br />
                <label>{t("select region")}</label>
                <Select
                    multiple
                    options={regionList}
                    id="idSubRegion"
                    placeholder={t('selectOption')}
                    value={userSubR.value}
                    onClear={() => setUserSubR({value: []})}
                    onChange={handleChangeSubRegions}
                    readOnly={!emailSCA & (modifyFlag | hpFlag)}
                    disabled={userLvlLock}
                /> <br />
                <label>{t("approvalLevel")}</label>
                <Select
                    clearIcon={false}
                    value={userLvl}
                    options={levelList}
                    onChange={(val) => setUserLvl([val.value])}
                    disabled={userLvlLock}
                    readOnly={hpFlag}
                />
            </Modal>
            <Row>
                <Col 
                    style={{
                        position: "absolute",
                        marginTop: "5px",
                    }}
                >
                    <div style={{ width: '270px', }} >
                        <Button appearance="success" onClick={() => setShowModal(true)} >{t('addNew')}</Button>
                    </div>
                </Col>
            </Row>
            <div>
                <Table
                    onClick = {modifyReg}
                    columns = {[
                        {
                            id: 'customer',
                            label: t("channels"),
                            filter: (
                                <Search
                                    id="channel-filter"
                                    value={channelFilter}
                                    onChange={(val) => {
                                        setChannelFilter(val);
                                        setCurrentPage(1);
                                    }}
                                />
                            )
                        },
                        {
                            id: 'name',
                            label: t("contactName")
                        },
                        {
                            id: 'jobPosition',
                            label: t("jobPosition")
                        },
                        {
                            id: 'idUser',
                            label: t("Email"),
                            filter: (
                                <Search
                                    id="email-filter"
                                    value={emailFilter}
                                    onChange={(val) => {
                                        setEmailFilter(val);
                                        setCurrentPage(1);
                                    }}
                                />
                            )
                        },
                        {
                            id: 'idCountry',
                            label: t("Country")
                        },
                        {
                            id: 'subRegion',
                            label: t("Subregion")
                        },
                        {
                            id: 'levelName',
                            label: t("approvalLevel")
                        }
                    ]}
                    showFilters
                    columnReorder
                    data={pagedData}
                    loading={loadingData}
                    onSort={handleSort}
                    onColumnReorder={(reOrder) => setOrder(reOrder)}
                    preferences={{
                        defaultOrder: order,
                        sortBy: {
                            id: orderBy,
                            type: orderType,
                        },
                        order: order
                    }}
                    pagination={{
                        currentPage,
                        onPageChange: handlePageChange,
                        pageSize,
                        totalItems: filteredData.length,
                    }}
                />
                <div style={{ textAlign: "left" }}>
                    <Button
                        onClick={()=>{
                            setTimeout(() => {
                            const dataXlsx = filteredData.map((item) => { return item; });
                            const ws = XLSX.utils.json_to_sheet(dataXlsx, { header: order });
                            const wb = XLSX.utils.book_new();
                            const date = moment(new Date()).format('YYYYMMDDHHmm');
                            const filename = 'UserViewData-' + date + '.xlsx';
                            const ws_name = "UserViewData";
                            XLSX.utils.book_append_sheet(wb, ws, ws_name);
                            XLSX.writeFile(wb, filename);
                            }, 750);
                        }}
                        disabled={filteredData.length === 0}
                        leadingIcon={<IconDownload />}
                        title={t('download data')}
                    >
                        {t('download')}
                    </Button>
                </div>
            </div>
        </div>
    );

}

export default SpecialConditionApproversView;